export enum conversionStatusTypes {
  COMPLETED = 'completed',
  PROCESSING = 'processing',
  FAILED = 'failed',
}
